import {Component, OnInit} from "@angular/core";
import {UUID} from "angular2-uuid";
import {ActivatedRoute, Router} from "@angular/router"
import {HttpApiService} from "../../../services/http-api.service";
import {SharedService} from "../../../services/shared.service";
import {DomSanitizer} from "@angular/platform-browser";
import {Constants} from "../../../services/constants";
import {EndpointsService} from "../../../services/endpoints.service";
import {UserService} from "../../../services/user.service";

declare var sha256: any;

@Component({
  selector: 'app-onebill-checkout',
  templateUrl: './onebill-checkout.component.html',
  styleUrls: ['../rfq/rfq.component.scss', './onebill-checkout.component.scss']
})
export class OnebillCheckoutComponent implements OnInit {
  isCreated: boolean = false;
  hasError: boolean = false;
  errorMessage: any;
  successMessage: string;
  profile: any = {};
  pricingPlans: any;
  planId: any;
  selectedPricingPlan: any = {};
  quantity: number = 1;
  showLicenseModal: boolean = false;
  agreeToTerms: boolean = false;
  selectedTierId: number = 1;
  selectedTier: any;

  private iframeUrl: any;
  private order: any = {};
  private frameHeight: number = 600;
  private user: any;
  private secretKey: string;
  private formStep: number = 1;

  constructor(private sharedService: SharedService,
              private api: HttpApiService,
              private endpoints: EndpointsService,
              private route: ActivatedRoute,
              private router: Router,
              private userService: UserService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.userService.getCurrentUser()
      .then(user => {
        this.user = user;
      });
    this.loadData();
  }

  loadData() {
    this.route.queryParams
      .subscribe(data => {
        let profileId = this.sharedService.decodeBase64(data['profileId']);
        this.planId = data['planId'];
        this.profile = this.sharedService.getData("selectedProfile");
        this.profile = this.profile ? this.profile : {};

        this.quantity = data["quantity"] ? data["quantity"] : 1;
        this.quantity = parseInt(this.quantity.toString());
        if (!this.profile || this.profile.id != profileId) {
          //load current profile from server
          this.api.get(this.endpoints.getProfileUrl() + "/" + profileId + "?domain=" + Constants.TENANT_ID())
            .subscribe(profile => {
              this.profile = profile;
              this.setSelectedPlan();
            });
        } else {
          this.setSelectedPlan();
        }

      });
  }

  setSelectedPlan() {
    this.pricingPlans = this.profile.details.pricingPlans;
    this.pricingPlans.forEach(item => {
      if (item.planId === this.planId) {
        this.selectedPricingPlan = item;
        if(this.selectedPricingPlan.pricingTiers && this.selectedPricingPlan.pricingTiers.length>0){
          this.selectedTierId = this.selectedPricingPlan.pricingTiers[0].id;
          this.selectedTier = this.selectedPricingPlan.pricingTiers[0];
        }
      }
    });
  }

  selectPricingPlan(planId) {
    this.planId = planId;
    this.setSelectedPlan();
  }

  onSelectTier(tierId){
    this.selectedTier = this.selectedPricingPlan.pricingTiers.filter(item => item.id == tierId)[0];
  }


  back() {
    this.sharedService.navigateToProfile(this.profile, this.router);
  }

  gotoNextFormStep(){
    if(!this.agreeToTerms){
      this.showModal();
      return;
    }
    this.sharedService.setData("selectedProfile", this.profile);
    this.router.navigateByUrl("/buyer/onebill-payment?profileId=" + this.sharedService.encodeBase64(this.profile.id) + "&planId=" + this.planId  + "&tierId=" + this.selectedTierId  + "&quantity=" + this.quantity);

  }

  showModal(){
    this.showLicenseModal = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/onebill-checkout/onebill-checkout.component.ts